"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeButton = exports.errorIcon = exports.errorText = exports.errorBar = void 0;

var _react = require("@emotion/react");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 16px !important;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: #b00020;\n  margin-left: 12px;\n  padding-top: 2px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 12px;\n  background-color: #feefec;\n  border-radius: 4px;\n  padding: 16px 24px;\n  display: flex;\n  justify-content: flex-start;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var errorBar = (0, _react.css)(_templateObject());
exports.errorBar = errorBar;
var errorText = (0, _react.css)(_templateObject2());
exports.errorText = errorText;
var errorIcon = (0, _react.css)(_templateObject3());
exports.errorIcon = errorIcon;
var closeButton = (0, _react.css)(_templateObject4());
exports.closeButton = closeButton;